<template>
  <div class="h-100">
    <Base
      v-if="isLoaded"
      ref="baseComponent"
      :on-submit="onSubmit"
      :triger-prevent="trigerPrevent"
      :field-details-route="fieldDetailsRoute"
      :templates-route="templatesRoute"
      :show-teams="showTeams"
      :isOne="isOne"
      :isTicket="isTicket"
      :groupName="groupName"
    />
    <Loader v-else />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import Base from './base';
import Loader from '../../../common/loader';
import { ReportsMixin } from '../../../../../mixins';

import { VALIDATION_RULES } from '../../../../../../../../constants';

export default {
  title: 'EditCaseTemplate',
  components: { Base, Loader },
  mixins: [ReportsMixin],
  props: {
    onSubmit: {
      type: Function,
      default: () => {},
    },
    onGet: {
      type: Function,
      default: () => {},
    },
    trigerPrevent: {
      type: Function,
      default: () => {},
    },
    fieldDetailsRoute: {
      type: String,
      default: '',
    },
    showTeams: {
      type: Boolean,
      default: true,
    },
    isOne: {
      type: Boolean,
      default: false,
    },
    isTicket: {
      type: Boolean,
      default: false,
    },
    templatesRoute: {
      type: String,
      default: '',
    },
    groupName: {
      type: String,
      default: 'Group',
    },
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  computed: {
    ...mapState({
      templates: (state) => state.template.templates,
    }),
  },
  async created() {
    this.isLoaded = false;
    const id = this.$route.params.id;
    if (this.templates && this.templates[id]) {
      this.isLoaded = true;
      return;
    }
    const response = await this.onGet(id);

    const template = response.data;

    const groups = template.groups;
    const groupsFields = {};

    template.fields.forEach((f) => {
      f.type = f.entryType;
      f.values = f.values.map((v) => ({ id: this.getID(), value: v }));
      f.mappedValues = f.mappedValues.map((v) => ({ id: this.getID(), value: v.value, key: v.key }));
      if (f.rules && f.rules.length) {
        const rulesList = f.rules.map((r) => r.name);
        const newRules = {};
        if (rulesList.includes(VALIDATION_RULES.REQUIRED)) {
          f.required = true;
        }
        if (rulesList.includes(VALIDATION_RULES.IS_ATTACH_FILE_TO_EMAIL)) {
          f.isAttachFileToEmail = true;
        }
        if (rulesList.includes(VALIDATION_RULES.MIN)) {
          newRules.min = f.rules.find((r) => r.name === VALIDATION_RULES.MIN).value;
        }
        if (rulesList.includes(VALIDATION_RULES.MAX)) {
          newRules.max = f.rules.find((r) => r.name === VALIDATION_RULES.MAX).value;
        }
        if (rulesList.includes(VALIDATION_RULES.LIMIT)) {
          newRules.limit = f.rules.find((r) => r.name === VALIDATION_RULES.LIMIT).value;
        }
        if (rulesList.includes(VALIDATION_RULES.MIN_LENGTH)) {
          newRules.minLength = f.rules.find((r) => r.name === VALIDATION_RULES.MIN_LENGTH).value;
        }
        if (rulesList.includes(VALIDATION_RULES.LENGTH)) {
          newRules.length = f.rules.find((r) => r.name === VALIDATION_RULES.LENGTH).value;
        }
        if (rulesList.includes(VALIDATION_RULES.SIZE_IN_PDF)) {
          newRules.sizeInPDF = f.rules.find((r) => r.name === VALIDATION_RULES.SIZE_IN_PDF).value;
        }
        if (rulesList.includes(VALIDATION_RULES.AUTOMATICALLY_SELECTED)) {
          newRules.automaticallySelected = Boolean(f.rules.find((r) => r.name === VALIDATION_RULES.AUTOMATICALLY_SELECTED).value);
        }
        if (rulesList.includes(VALIDATION_RULES.REQUIRED_WHEN)) {
          const requiredWhenRules = f.rules.find((r) => r.name === VALIDATION_RULES.REQUIRED_WHEN);
          f.requiredWhenRules = {
            fieldIdentity: requiredWhenRules.referenceField,
            value: requiredWhenRules.referenceComparison,
          };
        }

        f.rules = newRules;
      } else {
        f.rules = {};
      }

      if (groupsFields[f.groupId]) {
        groupsFields[f.groupId].push(f);
      } else {
        groupsFields[f.groupId] = [f];
      }
    });

    groups.forEach((g) => {
      g.fields = groupsFields[g.id];
    });

    this.setTemplate({
      id,
      template: { groups: groups, caseDetails: template },
    });
    this.isLoaded = true;
  },
  methods: {
    ...mapActions({ setTemplate: 'template/setTemplate' }),
    exit() {
      return this.$refs.baseComponent.exit();
    },
    getID() {
      return `${Math.round(Math.random() * 10000)}_${new Date().getTime()}`;
    },
  },
};
</script>
